import { idParam, ROLES } from "../../../helpers/commons.helpers";
/**
 * Reservation route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route contains a `meta` object used by navigation
 * guards and permission checks and some routes include a `beforeEnter` guard
 * that sets the purchase type in the store depending on query parameters.
 *
 * @typedef {Object} ReservationRouteMeta
 * @property {boolean} requiresAuth - When true the route requires authentication.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @typedef {import('vue-router').NavigationGuard} NavigationGuard
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "reservations",
        name: "Reservations",
        meta: {
            title: "Reservations",
            requiresAuth: true,
            roles: [ROLES.SUPPLIER, ROLES.SUPPLIER_ACCESS, ROLES.DISPATCH]
        },
        component: () =>
            import(
            /* webpackChunkName: "reservations" */ "../pages/Reservations.vue"
            )
    },
    {
        path: "/reservations/new",
        name: "NewReservation",
        meta: {
            title: "New Reservation",
            requiresAuth: true,
            roles: [ROLES.SUPPLIER, ROLES.SUPPLIER_ACCESS, ROLES.DISPATCH]
        },
        component: () =>
            import(
            /* webpackChunkName: "reservations" */ "../pages/NewReservations.vue"
            )
    },
    {
        path: `/reservations/${idParam()}`,
        name: "EditReservation",
        meta: {
            title: "Edit Reservation",
            requiresAuth: true,
            roles: [ROLES.SUPPLIER, ROLES.SUPPLIER_ACCESS, ROLES.DISPATCH]
        },
        component: () =>
            import(/* webpackChunkName: "reservation" */ "../pages/EditReservations.vue")
    },
]